import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import notepadIcon from '../../../../../../assets/svg/notepad.svg';
import { store as mainStore } from '../../../../../../store';
import { store } from './Driver';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '&>*': {
      marginBottom: theme.spacing(1),
    },
  },
  noteField: {
    background: `url(${notepadIcon}) no-repeat`,
    backgroundSize: '50px',
    backgroundPosition: '10px',
  },
}));

function AddNote() {
  const { id } = useParams();
  const classes = useStyles();
  const [note, setNote] = useState('');
  const [error, setError] = useState(false);
  const { state, dispatch } = useContext(store);
  const { addNote } = state;
  const { showMessage, showError } = useContext(mainStore);

  const handleChangeTF = (e) => {
    const { value } = e.target;
    setNote(value);
  };
  const handleAddNote = async () => {
    setError(false);
    if (note) {
      const response = await addNote(id, note);
      if (response.ok) {
        showMessage(response.messages);
        dispatch({ type: 'NOTES', payload: response.notes });
        setNote('');
      } else {
        showError(response);
      }
    } else {
      setError('متن یادداشت بایستی وارد شود.');
    }
  };
  return (
    <div className={classes.root}>
      <Typography component="h2" variant="h2">
        یادداشت:
      </Typography>
      <div>
        <TextField
          fullWidth
          value={note}
          onChange={handleChangeTF}
          label="متن یادداشت لازم جهت این کاربر"
          multiline
          rows={3}
          size="small"
          variant="outlined"
          className={classes.noteField}
          error={error ? true : false}
          helperText={error ? error : ''}
        />
      </div>

      <Button
        onClick={handleAddNote}
        variant="contained"
        fullWidth
        color="primary"
      >
        افزودن
      </Button>
    </div>
  );
}

export default React.memo(AddNote);
